import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import injectTranslate from 'i18n/hoc/injectTranslate'

import { Icon } from '@quotatisgroup/uikit-public.ui.icon'

import { fromPro, fromRouting, fromFirm } from 'store/selectors'
import {
  toggleSignInProPopin,
  proAuthLogout,
  togglePopinDisplay,
} from 'store/actions'
import {
  CANDIDATE_STATUS_PACKAGE,
  PACKAGE_STATUS_NOT_SUBSCRIBE,
} from 'constants/packageStatus'
import { URLS } from 'constants/urls'
import {
  RouterLinkStyled,
  StyledLink,
  UniverseLinkStyled,
} from './AccountButtonStyle'
import { UNIVERSES } from 'constants/routes'

const AccountButton = ({ isLoggedIn, translate, packageStatus, firstName }) => {
  if (!isLoggedIn) {
    return (
      <UniverseLinkStyled
        id="header-connection-link"
        universe={UNIVERSES.PRO}
        path="/my-account/dashboard"
      >
        {translate('header.connection.link')}
      </UniverseLinkStyled>
    )
  }
  return (
    <StyledLink>
      <RouterLinkStyled
        id="header-nickname-link"
        to={
          packageStatus === CANDIDATE_STATUS_PACKAGE
            ? URLS.ROUTES.CANDIDATE_PACKAGE
            : URLS.ROUTES.PRO_DASHBOARD
        }
      >
        <Icon name="login" color="primary" size="sm" margin="right-xs" />
        {firstName}
      </RouterLinkStyled>
    </StyledLink>
  )
}

const mapStateToProps = state => {
  const email = fromPro.getEmail(state)
  const id = fromPro.getFirmId(state)
  const firstName = fromFirm.getFirmFirstNameOwner(state, id, email)

  return {
    isLoggedIn: fromPro.isLoggedIn(state),
    isLandingPage: fromRouting.isLandingPage(state),
    packageStatus: fromFirm.getPackageStatus(state, fromPro.getFirmId(state)),
    firstName,
  }
}

const mapDispatchToProps = dispatch => ({
  toggleAccountNavigation: popInDisplayFlag => () =>
    dispatch(togglePopinDisplay(popInDisplayFlag)),
  toggleProSignInPopin: () => dispatch(toggleSignInProPopin()),
  proLogout: () => dispatch(proAuthLogout()),
})

AccountButton.propTypes = {
  isLoggedIn: PropTypes.bool,
  translate: PropTypes.func,
  packageStatus: PropTypes.number,
  firstName: PropTypes.string,
}

AccountButton.defaultProps = {
  packageStatus: PACKAGE_STATUS_NOT_SUBSCRIBE,
  isLoggedIn: false,
  firstName: undefined,
}

export default injectTranslate(
  connect(mapStateToProps, mapDispatchToProps)(AccountButton),
)
